import { motion, useReducedMotion } from "framer-motion";

const line = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.76, 0, 0.24, 1],
      delay: 0.15 + i * 0.09,
    },
  }),
};

// Renders a heading line with a masked reveal (word-level or full line).
export const MaskLine = ({ children, delay = 0, className = "" }) => {
  const reduced = useReducedMotion();
  if (reduced) return <span className={className}>{children}</span>;
  return (
    <span className="reveal-mask">
      <motion.span
        className={className}
        style={{ display: "inline-block" }}
        variants={line}
        custom={delay}
        initial="hidden"
        animate="show"
      >
        {children}
      </motion.span>
    </span>
  );
};

// Fade-up used for scroll-reveal
export const FadeUp = ({ children, delay = 0, y = 24, className = "", once = true }) => {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
};

export const Stagger = ({ children, delay = 0, className = "" }) => {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: 0.08, delayChildren: delay } },
      }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = "" }) => {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y: 24 },
        show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
      }}
    >
      {children}
    </motion.div>
  );
};
